import HeroImage from './HeroImage'

export default HeroImage
